export default __webpack_public_path__ + "static/media/86b09587299fad3493664e5182d131f4.7665470c.png";